import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';
import { Icon } from '/imports/ui/Icon';

const InfoIconStyled = styled.span`
  .icon {
    margin-left: 0.5rem;
    position: relative;
    top: 0.2rem;
    cursor: pointer;
    svg {
      width: 1rem;
      * {
        stroke: ${css.grey4};
        stroke-width: 2px;
      }
    }
    &:hover {
      svg {
        * {
          stroke: ${css.primaryColor};
        }
      }
    }
  }
`;

interface InfoIconProps {
  className?: string;
  tip: string;
}

/** Help icon that reveals a tooltip on click. */
export const InfoIcon = (props: InfoIconProps) => {
  return (
    <InfoIconStyled className={props.className}>
      <Icon icon="help" tip={props.tip} tipEvents={{ click: true }} />
    </InfoIconStyled>
  );
};